import axios from '../utils/axios';

export default function reindexJobs(adminId, data) {
    return axios.post('/admin/' + adminId + '/jobs/reindex', data)
        .then((res) => res.data);
}
